import { render, staticRenderFns } from "./MotorCoach.vue?vue&type=template&id=4b3dc9eb"
import script from "./MotorCoach.vue?vue&type=script&lang=js"
export * from "./MotorCoach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports